var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-add-circle",
    d: "M12,23.5A11.5,11.5,0,1,1,23.5,12,11.51,11.51,0,0,1,12,23.5Zm0-22A10.5,10.5,0,1,0,22.5,12,10.51,10.51,0,0,0,12,1.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-add-circle",
    d: "M16.17,11.43a.79.79,0,0,1-.57,1.36H12.79v2.79a.81.81,0,0,1-.22.58.82.82,0,0,1-1.14,0,.81.81,0,0,1-.22-.58V12.79H8.4a.79.79,0,1,1,0-1.58h2.81V8.4a.79.79,0,1,1,1.58,0v2.81H15.6A.77.77,0,0,1,16.17,11.43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add_circle.084f524ed590c4767c56136f903b033a.svg";
export { ForwardRef as ReactComponent };